/**
 * Returns the current date, or a fixed date in test environments to ensure consistent tests.
 * @returns {Date} The current date, or a fixed date in test environments to ensure consistent tests.
 */
export default function currentDate() {
  if (window.RAILS_ENV == "test" && window.CURRENT_TIME) {
    return new Date(Date.parse(window.CURRENT_TIME))
  }

  return new Date()
}
